import { render } from "./FPluginTreeTab.vue?vue&type=template&id=0de5f310&scoped=true"
import script from "./FPluginTreeTab.vue?vue&type=script&lang=js"
export * from "./FPluginTreeTab.vue?vue&type=script&lang=js"

import "./FPluginTreeTab.vue?vue&type=style&index=0&id=0de5f310&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de5f310"]])

export default __exports__